import universal from 'react-universal-component';
import universalImport from 'babel-plugin-universal-import/universalImport';
import path from 'path';
import LazyComponent from '../../../LazyComponent';

export default universal(
    universalImport({
        chunkName: () => 'LazyOrderDetailsChunk',
        path: () => path.join(__dirname, './OrderDetailsConnect'),
        resolve: () => require.resolveWeak('./OrderDetailsConnect'),
        load: () =>
            Promise.all([
                import(/* webpackChunkName: "LazyOrderDetailsChunk" */ './OrderDetailsConnect'),
            ]).then((proms) => proms[0]),
    }),
    LazyComponent.loaderResource
);
